<template>
  <el-dialog
    :title="cdia.title"
    :visible.sync="cdia.show"
    v-if="cdia.show"
    :close-on-click-modal="false"
  >
    <div class="c-dia">
      <div class="head">章节名称</div>
      <div v-for="x in listData" class="c-item" :key="x.uuid">
        {{ x.chapterName }}
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="closeFrom()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { chapterList } from "@/api/book";

export default {
  components: { butn },
  props: ["cdia"],
  data() {
    return {
      listData: [],
    };
  },
  methods: {
    closeFrom() {
      this.$emit("closeDia", "cdia");
    },
  },
  created() {
    chapterList(this.cdia.uuid)
      .then(({ data, code }) => {
        if (code === 0) {
          this.listData = data;
        }
      })
      .catch(() => {});
  },
};
</script>

<style lang="scss" scoped>
.c-dia {
  max-height: 390px;
  overflow: auto;
  border: 1px solid #dcdcdc;
  .head {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  }
  .c-item {
    line-height: 40px;
    border-top: 1px solid #dcdcdc;
    text-indent: 1em;
  }
  .c-item:nth-of-type(even) {
    background: #f2f2f2;
  }
}
</style>
